import gql from 'graphql-tag'

export const getBulkExportMutation = gql`
  mutation getBulkExportData(
    $purpose: String
    $itemTypeId: String
    $itemTypeLabel: String
    $bulkType: String
    $vendorCompleteState: Boolean
  ) {
    getBulkExportData(
      itemTypeId: $itemTypeId
      purpose: $purpose
      itemTypeLabel: $itemTypeLabel
      bulkType: $bulkType
      vendorCompleteState: $vendorCompleteState
    ) {
      ExcelExportResponse
      errors
    }
  }
`
export const getBulkExportFailureMutation = gql`
  mutation bulkExportFailure($requestId: String) {
    getBulkExportFailureData(requestId: $requestId) {
      ExcelExportResponse
      errors
    }
  }
`

export const getBulkLovMutation = gql`
  mutation getBulkLov($lovType: String, $itemState: String) {
    getBulkLovData(lovType: $lovType, itemState: $itemState) {
      attribute
      description
      count
    }
  }
`
